// Single source of truth for ticket statuses across the app.
// Strict 3-status model: Created → Work in Progress → Closed.

export const TICKET_STATUSES = [
  { key: "all",         label: "All" },
  { key: "created",     label: "Created",         color: "#3072FF", bg: "#EEF3FF" },
  { key: "in_progress", label: "Work in Progress", color: "#D97706", bg: "#FFFBEB" },
  { key: "closed",      label: "Closed",          color: "#475569", bg: "#F1F5F9" },
];

export const STATUS_META = Object.fromEntries(
  TICKET_STATUSES.filter((s) => s.key !== "all").map((s) => [s.key, s])
);

export const PRIORITY_META = {
  high:   { label: "High",   color: "#B91C1C", bg: "#FEF2F2" },
  medium: { label: "Medium", color: "#D97706", bg: "#FFFBEB" },
  low:    { label: "Low",    color: "#475569", bg: "#F1F5F9" },
};

export const ROLE_LABEL = {
  admin:            "MediMagic Support",
  state_admin:      "State Admin",
  university_admin: "University Admin",
  college_admin:    "College Admin",
  it_admin:         "IT Admin",
  support_user:     "Support User",
  faculty:          "Faculty",
};
